import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Title from "../../components/title";
import "./ComeLeave.css";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { Form, Spinner } from "react-bootstrap";
import RegisterTextbox from "../../components/RegisterTextBox";
import RegisterSelect from "../../components/RegisterSelect";
import CustomButton from "../../components/CustomButton";
import RegisterRadio from "../../components/Radio";
import API from "../../api/axiosConfig";
import TestPreLoader from "../TestPreLoader/TestPreLoader";
import { useNavigate } from "react-router";


function ComeLeave() {
  const [registerType, setRegisterType] = useState("يدوي"); // Default selection
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [name, setName] = useState("");
  const [type, setType] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [message, setMessage] = useState('');

  const navigate = useNavigate();

  const handleRadioChange = (e) => {
    setRegisterType(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const mForm = new FormData();
    mForm.append("name", name);
    mForm.append("type", type);
    try {
      const res = await API.post("attendances/store", mForm);
      const data = await res;
      navigate("/hrreport/attendancedeparturereport");
    } catch (error) {
      setError(error.response.data.errors);
      setIsSubmitting(false);
      setMessage(error.response.data.message);
    }
  };

  const getEmployee = async () => {
    try {
      const res = await API.post("employees");
      const data = await res;
      console.log(data.data);
      setEmployees(data.data);
      setLoading(false);
    } catch (error) {
      setError(error.response.data.errors);
    }
  };

  useEffect(() => {
    getEmployee();
  }, []);

  return (
    loading ? <TestPreLoader /> :
      <>
        <div className="ComeLeave">
          <Title
            title="الحضور والإنصراف"
            icon={<FontAwesomeIcon icon={faUserPlus} />}
          />
          <Form className="comeleaveContainer" onSubmit={handleSubmit}>
            <div className="radioContainer radioContainer3">
              <h5>نوع التسجيل</h5>
              <div className="clientRadios clientRadios3">
                <RegisterRadio
                  label="يدوي"
                  value="يدوي"
                  checked={registerType === "يدوي"}
                  onChange={handleRadioChange}
                />
                <RegisterRadio
                  label="QR"
                  value="QR"
                  checked={registerType === "QR"}
                  onChange={handleRadioChange}
                />
              </div>
            </div>
            {message && <div className="success-message">{message}</div>}
            {registerType === "يدوي" && (
              <>
                <RegisterSelect
                  id="empName"
                  label="إسم الموظف"
                  stylee={{ width: "45%" }}
                  parentStyle={{ width: "30%", marginBottom: "20px" }}
                  options={[
                    { value: "", label: " اختر موظفا" },
                    ...employees.map((emp) => ({
                      value: emp.id,
                      label: emp.name,
                    })),
                  ]}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  name="name"
                  error={error && error.name}

                />
{/* 
                <RegisterTextbox
                  parentStyle={{
                    width: "30%",
                    marginBottom: "20px",
                  }}
                  id="time"
                  label="التوقيت"

                  type="time"
                  stylee={{ width: "30%" }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  name="name"
                  error={error && error.name}
                  autoFocus

                /> */}

                <RegisterSelect
                  id="location"
                  label="حضور - إنصراف"
                  stylee={{ width: "40% !important" }}
                  parentStyle={{
                    width: "30%",
                    marginBottom: "20px",
                  }}
                  options={[
                    { value: "", label: "إختر" },
                    { value: "1", label: "حضور" },
                    { value: "2", label: "إنصراف" },
                  ]}
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                />
                {error && error.type && <div className="error">{error.type}</div>}
              </>
            )}

            {registerType === "QR" && (
              <>
                <RegisterTextbox
                  parentStyle={{
                    width: "30%",
                    marginBottom: "20px",
                  }}
                  id="QR"
                  label="QR Code"

                  type="text"
                  stylee={{ width: "30%" }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  name="name"
                  error={error && error.name}
                  autoFocus

                />
                {/* {error && error.name && <div className="error">{error.name}</div>} */}
                <RegisterSelect
                  id="location"
                  label="حضور - إنصراف"
                  stylee={{ width: "40% !important" }}
                  parentStyle={{
                    width: "30%",
                    marginBottom: "20px",
                  }}
                  options={[
                    { value: "", label: "إختر" },
                    { value: "1", label: "حضور" },
                    { value: "2", label: "إنصراف" },
                  ]}
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  error={error && error.type}
                />
                {/* {error && error.type && <div className="error">{error.type}</div>} */}
              </>
            )}
            {
              isSubmitting ? <Spinner animation="border" variant="primary" /> :
                <CustomButton text="حفظ" />
            }
          </Form>
        </div>
      </>
  );
}

export default ComeLeave;
